export default __webpack_public_path__ + "static/media/cloud-main.1204f4f3.jpg";